import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M15.856 14.857a1 1 0 0 1-1 1H5.144a1 1 0 0 1-1-1v-2.602h11.712v2.601Zm0-5.602v1.5H4.144v-1.5zm-1-5.111a1 1 0 0 1 1 1v2.61H4.144v-2.61a1 1 0 0 1 1-1z" />
    <path d="M1.62 15.881v-1.94a.5.5 0 1 1 1 0v1.94a1.5 1.5 0 0 0 1.5 1.5h1.94l.1.01a.5.5 0 0 1 0 .98l-.1.01H4.12a2.5 2.5 0 0 1-2.5-2.5m15.761 0v-1.94a.5.5 0 1 1 1 0v1.94a2.5 2.5 0 0 1-2.5 2.5h-1.94a.5.5 0 0 1 0-1h1.94a1.5 1.5 0 0 0 1.5-1.5M1.62 6.06V4.12a2.5 2.5 0 0 1 2.5-2.5h1.94l.101.01a.5.5 0 0 1 0 .98l-.1.01H4.12a1.5 1.5 0 0 0-1.5 1.5v1.94l-.01.1a.5.5 0 0 1-.98 0zm15.762 0V4.12a1.5 1.5 0 0 0-1.347-1.493l-.153-.008h-1.94a.5.5 0 1 1 0-1h1.94l.255.013a2.5 2.5 0 0 1 2.245 2.487v1.94a.5.5 0 0 1-1 0ZM3.277 10.755l-.076-.004a.75.75 0 0 1 0-1.492l.076-.004h13.428a.75.75 0 1 1 0 1.5z" />
  </svg>
);
export default SvgScanner;
